import {Component, OnInit, EventEmitter, Output, Input, HostListener} from '@angular/core';

@Component({
  selector: 'taxihandgo-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  private _checked: boolean = false;
  @Output() checkedChange = new EventEmitter<boolean>();
  constructor() { }

  ngOnInit() {
  }

  @Input()
  get checked(){
    return this._checked;
  }

  set checked(value: boolean){
    this._checked = value;
  }

  @HostListener('click')
  public toggle(){
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

  public unselect(){
    this.checked = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/checkbox/checkbox.component.ts